export default {
	$accessibility: {
		archived: "Arquivado",
		present: "Presente",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Oculto do Receptor",
			hidden_from_sender: "Oculto do Remetente",
			private: "Privado",
			shared_with_custom: "Compartilhado com Personalizado",
			shared_with_everyone: "Compartilhado com Todos",
			shared_with_receiver: "Compartilhado com o Receptor",
			shared_with_sender: "Compartilhado com o Remetente",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB de Armazenamento",
		limitMBStorage: "{limit}MB de Armazenamento",
		limitUser: "{limit} Usuário",
		limitUsers: "{limit} Usuários",
		renewAtPricePerUnit: "Renovará em {currency}{price} por {unit}",
		unlimitedModule: "{module} Ilimitado",
		upToLimitModule: "Até {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TURQUIA",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1spt!2str!4v1701805110461!5m2!1spt!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Acelere o seu negócio com Antrego. Gerencie seus processos de envio digitalmente, de forma segura e fácil.",
	},
	$cookieBanner: {
		accept: "Aceitar",
		decline: "Recusar",
		message:
			"Utilizamos cookies e tecnologias semelhantes para análise e conteúdo personalizado. Ao clicar em 'Aceitar', você consente com o uso dessas tecnologias.",
	},
	$country: {
		afghanistan: "Afeganistão",
		aland: "Ilhas Åland",
		albania: "Albânia",
		algeria: "Argélia",
		american_samoa: "Samoa Americana",
		andorra: "Andorra",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Antártica",
		antigua_and_barbuda: "Antígua e Barbuda",
		argentina: "Argentina",
		armenia: "Armênia",
		aruba: "Aruba",
		australia: "Austrália",
		austria: "Áustria",
		azerbaijan: "Azerbaijão",
		bahamas: "Bahamas",
		bahrain: "Bahrein",
		bangladesh: "Bangladesh",
		barbados: "Barbados",
		belarus: "Bielorrússia",
		belgium: "Bélgica",
		belize: "Belize",
		benin: "Benin",
		bermuda: "Bermudas",
		bhutan: "Butão",
		bolivia: "Bolívia",
		bonaire_sint_eustatius_and_saba: "Bonaire, Santo Eustáquio e Saba",
		bosnia_and_herzegovina: "Bósnia e Herzegovina",
		botswana: "Botsuana",
		bouvet_island: "Ilha Bouvet",
		brazil: "Brasil",
		british_indian_ocean_territory: "Território Britânico do Oceano Índico",
		british_virgin_islands: "Ilhas Virgens Britânicas",
		brunei: "Brunei",
		bulgaria: "Bulgária",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Cabo Verde",
		cambodia: "Camboja",
		cameroon: "Camarões",
		canada: "Canadá",
		cayman_islands: "Ilhas Cayman",
		central_african_republic: "República Centro-Africana",
		chad: "Chade",
		chile: "Chile",
		china: "China",
		christmas_island: "Ilha Christmas",
		cocos_islands: "Ilhas Cocos [Keeling]",
		colombia: "Colômbia",
		comoros: "Comores",
		congo_republic: "República do Congo",
		cook_islands: "Ilhas Cook",
		costa_rica: "Costa Rica",
		croatia: "Croácia",
		cuba: "Cuba",
		curacao: "Curaçao",
		cyprus: "Chipre",
		czechia: "Tchéquia",
		denmark: "Dinamarca",
		djibouti: "Djibouti",
		dominica: "Dominica",
		dominican_republic: "República Dominicana",
		dr_congo: "República Democrática do Congo",
		ecuador: "Equador",
		egypt: "Egito",
		el_salvador: "El Salvador",
		equatorial_guinea: "Guiné Equatorial",
		eritrea: "Eritreia",
		estonia: "Estônia",
		eswatini: "Essuatíni",
		ethiopia: "Etiópia",
		falkland_islands: "Ilhas Falkland",
		faroe_islands: "Ilhas Faroé",
		fiji: "Fiji",
		finland: "Finlândia",
		france: "França",
		french_guiana: "Guiana Francesa",
		french_polynesia: "Polinésia Francesa",
		french_southern_territories: "Territórios Franceses do Sul",
		gabon: "Gabão",
		gambia: "Gâmbia",
		georgia: "Geórgia",
		germany: "Alemanha",
		ghana: "Gana",
		gibraltar: "Gibraltar",
		greece: "Grécia",
		greenland: "Groenlândia",
		grenada: "Granada",
		guadeloupe: "Guadalupe",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernsey",
		guinea: "Guiné",
		guinea_bissau: "Guiné-Bissau",
		guyana: "Guiana",
		haiti: "Haiti",
		heard_island_and_mcdonald_islands: "Ilha Heard e Ilhas McDonald",
		honduras: "Honduras",
		hong_kong: "Hong Kong",
		hungary: "Hungria",
		iceland: "Islândia",
		india: "Índia",
		indonesia: "Indonésia",
		iran: "Irã",
		iraq: "Iraque",
		ireland: "Irlanda",
		isle_of_man: "Ilha de Man",
		israel: "Israel",
		italy: "Itália",
		ivory_coast: "Costa do Marfim",
		jamaica: "Jamaica",
		japan: "Japão",
		jersey: "Jersey",
		jordan: "Jordânia",
		kazakhstan: "Cazaquistão",
		kenya: "Quênia",
		kiribati: "Quiribati",
		kosovo: "Kosovo",
		kuwait: "Kuwait",
		kyrgyzstan: "Quirguistão",
		laos: "Laos",
		latvia: "Letônia",
		lebanon: "Líbano",
		lesotho: "Lesoto",
		liberia: "Libéria",
		libya: "Líbia",
		liechtenstein: "Liechtenstein",
		lithuania: "Lituânia",
		luxembourg: "Luxemburgo",
		macao: "Macau",
		madagascar: "Madagascar",
		malawi: "Malawi",
		malaysia: "Malásia",
		maldives: "Maldivas",
		mali: "Mali",
		malta: "Malta",
		marshall_islands: "Ilhas Marshall",
		martinique: "Martinica",
		mauritania: "Mauritânia",
		mauritius: "Maurício",
		mayotte: "Mayotte",
		mexico: "México",
		micronesia: "Micronésia",
		moldova: "Moldávia",
		monaco: "Mônaco",
		mongolia: "Mongólia",
		montenegro: "Montenegro",
		montserrat: "Montserrat",
		morocco: "Marrocos",
		mozambique: "Moçambique",
		myanmar: "Mianmar",
		namibia: "Namíbia",
		nauru: "Nauru",
		nepal: "Nepal",
		netherlands: "Países Baixos",
		new_caledonia: "Nova Caledônia",
		new_zealand: "Nova Zelândia",
		nicaragua: "Nicarágua",
		niger: "Níger",
		nigeria: "Nigéria",
		niue: "Niue",
		norfolk_island: "Ilha Norfolk",
		north_korea: "Coreia do Norte",
		north_macedonia: "Macedônia do Norte",
		northern_mariana_islands: "Ilhas Marianas do Norte",
		norway: "Noruega",
		oman: "Omã",
		pakistan: "Paquistão",
		palau: "Palau",
		palestine: "Palestina",
		panama: "Panamá",
		papua_new_guinea: "Papua Nova Guiné",
		paraguay: "Paraguai",
		peru: "Peru",
		philippines: "Filipinas",
		pitcairn_islands: "Ilhas Pitcairn",
		poland: "Polônia",
		portugal: "Portugal",
		puerto_rico: "Porto Rico",
		qatar: "Catar",
		reunion: "Reunião",
		romania: "Romênia",
		russia: "Rússia",
		rwanda: "Ruanda",
		saint_barthelemy: "São Bartolomeu",
		saint_helena: "Santa Helena",
		saint_lucia: "Santa Lúcia",
		saint_martin: "São Martinho",
		saint_pierre_and_miquelon: "São Pedro e Miquelão",
		samoa: "Samoa",
		san_marino: "São Marino",
		sao_tome_and_principe: "São Tomé e Príncipe",
		saudi_arabia: "Arábia Saudita",
		senegal: "Senegal",
		serbia: "Sérvia",
		seychelles: "Seicheles",
		sierra_leone: "Serra Leoa",
		singapore: "Singapura",
		sint_maarten: "Sint Maarten",
		slovakia: "Eslováquia",
		slovenia: "Eslovênia",
		solomon_islands: "Ilhas Salomão",
		somalia: "Somália",
		south_africa: "África do Sul",
		south_georgia_and_south_sandwich_islands: "Ilhas Geórgia do Sul e Sandwich do Sul",
		south_korea: "Coreia do Sul",
		south_sudan: "Sudão do Sul",
		spain: "Espanha",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "São Cristóvão e Nevis",
		st_vincent_and_grenadines: "São Vicente e Granadinas",
		sudan: "Sudão",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Svalbard e Jan Mayen",
		sweden: "Suécia",
		switzerland: "Suíça",
		syria: "Síria",
		taiwan: "Taiwan",
		tajikistan: "Tajiquistão",
		tanzania: "Tanzânia",
		thailand: "Tailândia",
		timor_leste: "Timor-Leste",
		togo: "Togo",
		tokelau: "Toquelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinidad e Tobago",
		tunisia: "Tunísia",
		turkiye: "Turquia",
		turkmenistan: "Turcomenistão",
		turks_and_caicos_islands: "Ilhas Turcas e Caicos",
		tuvalu: "Tuvalu",
		uganda: "Uganda",
		ukraine: "Ucrânia",
		united_arab_emirates: "Emirados Árabes Unidos",
		united_kingdom: "Reino Unido",
		united_states: "Estados Unidos",
		uruguay: "Uruguai",
		us_minor_outlying_islands: "Ilhas Menores Distantes dos EUA",
		us_virgin_islands: "Ilhas Virgens dos EUA",
		uzbekistan: "Uzbequistão",
		vanuatu: "Vanuatu",
		vatican_city: "Cidade do Vaticano",
		venezuela: "Venezuela",
		vietnam: "Vietnã",
		wallis_and_futuna: "Wallis e Futuna",
		western_sahara: "Saara Ocidental",
		yemen: "Iémen",
		zambia: "Zâmbia",
		zimbabwe: "Zimbábue",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Lira Turca",
		us_dollar: "Dólar Americano",
	},
	$documentManager: {
		message_1: 'Para editar o modelo, clique no botão "Editar Modelo" para acessar a tela de edição.',
		message_2: 'Você pode alterar o número de linhas na lista aumentando ou diminuindo a "Contagem de Linhas".',
		message_3: 'As alterações feitas nos campos de conteúdo aparecerão instantaneamente na seção "Pré-visualização".',
		message_4: 'Para gerar um PDF, clique no botão "Ações do Documento" para salvá-lo como PDF.',
		message_5: 'Para acessar os documentos posteriormente, você pode salvá-los através do botão "Ações do Documento".',
		message_6: "Os dados inseridos em cada célula da tabela serão refletidos exatamente na pré-visualização.",
		message_7: "A tabela de dados pode ser editada como uma planilha do Excel ou uma planilha eletrônica.",
	},
	$employeeType: {
		admin: "Administrador",
		default: "Padrão",
		exporter: "Exportador",
		importer: "Importador",
	},
	$format: {
		date: "DD/MM/YYYY",
		date_time: "DD/MM/YYYY HH:mm:ss",
		date_time_without_second: "DD/MM/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Crie sua empresa aqui.",
			create_company_title: "Deseja adicionar sua empresa?",
			description: "Você fez login com sucesso. Agora você precisa ingressar em uma empresa ou criar uma nova.",
			join_company_subtitle: "Digite seu código e ingresse na empresa aqui.",
			join_company_title: "Deseja ingressar em uma empresa existente?",
			title: "Bem-vindo {name}",
		},
		$unauthorized: {
			description: "Mantenha seus processos de exportação e importação sob controle usando o Antrego",
			forget_password_subtitle: "Digite seu e-mail para redefinir a senha.",
			sign_in_subtitle: "Faça login aqui",
			sign_in_title: "Já tem uma conta?",
			sign_up_subtitle: "Inscreva-se aqui",
			sign_up_title: "Quer criar uma conta?",
			title: "Bem-vindo ao Antrego",
		},
	},
	$invitationType: {
		company_partner: "Convite de Cooperação Comercial",
		customs_partner: "Convite de Parceiro Aduaneiro",
		employee: "Convite de Funcionário",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Transforme as Operações do Seu Negócio",
				hero_subtitle: "Benefícios da Plataforma",
				hero_description:
					"Descubra como a Antrego simplifica todo o seu fluxo logístico, da gestão de estoque ao rastreamento de remessas. Experimente maior eficiência, redução de custos e colaboração aprimorada em toda a sua organização.",
				features_title: "Benefícios Abrangentes da Plataforma",
				feature_1_title: "Painel Centralizado",
				feature_1_desc:
					"Acesse todos os seus dados logísticos, remessas, estoque e documentos em uma única interface intuitiva.",
				feature_2_title: "Maior Precisão de Dados",
				feature_2_desc:
					"Minimize erros com entrada de dados automatizada, validação e sincronização em tempo real entre todos os módulos.",
				feature_3_title: "Eficiência de Tempo",
				feature_3_desc:
					"Economize horas diariamente com fluxos de trabalho automatizados, notificações inteligentes e processos enxutos.",
				feature_4_title: "Colaboração da Equipe",
				feature_4_desc:
					"Habilite colaboração perfeita entre equipes internas, clientes, fornecedores e parceiros logísticos.",
				feature_5_title: "Redução de Custos",
				feature_5_desc:
					"Reduza custos operacionais por meio de maior eficiência, menos erros e alocação otimizada de recursos.",
				feature_6_title: "Escalabilidade",
				feature_6_desc: "Cresça com confiança com uma plataforma que escala sem esforço conforme suas necessidades.",
				benefits_title: "Por que Escolher a Antrego?",
				benefit_1: "Visibilidade completa em toda a sua cadeia de suprimentos",
				benefit_2: "Plataforma em nuvem segura com criptografia de nível corporativo",
				benefit_3: "Design responsivo para acesso em qualquer lugar",
				benefit_4: "Notificações automatizadas mantêm todas as partes informadas",
				benefit_5: "Fluxos de trabalho personalizáveis que se adaptam aos seus processos",
				benefit_6: "Equipe de suporte dedicada para garantir o seu sucesso",
				workflow_title: "Como a Antrego Transforma Suas Operações",
				step_1_title: "Consolide Suas Operações",
				step_1_desc:
					"Reúna gestão de estoque, rastreamento de remessas, tratamento de documentos e comunicação com clientes em uma plataforma integrada.",
				step_2_title: "Automatize Tarefas Rotineiras",
				step_2_desc:
					"Deixe a Antrego cuidar de tarefas repetitivas como entrada de dados, notificações e atualizações de status, liberando sua equipe para trabalhos estratégicos.",
				step_3_title: "Habilite Colaboração em Tempo Real",
				step_3_desc:
					"Compartilhe informações instantaneamente com todas as partes interessadas, garantindo acesso às atualizações e documentos mais recentes.",
				step_4_title: "Tome Decisões Baseadas em Dados",
				step_4_desc:
					"Aproveite análises e relatórios abrangentes para identificar tendências, otimizar processos e impulsionar a melhoria contínua.",
				cta_title: "Pronto para Transformar Suas Operações Logísticas?",
				cta_button: "Comece Grátis Hoje",
				cta_subtitle: "Não é necessário cartão de crédito • Junte-se a mais de 500 empresas",
			},
			benefits_title: "Benefícios da Plataforma",
			business_process: "Acelera seus processos empresariais.",
			control_title: "Assuma o controle com o Antrego.",
			highlight_word: "controle",
			risk_of_error: "Reduz o risco de erros.",
			text: "A Antrego transforma as operações logísticas de exportadores, importadores, agentes de carga e fabricantes com soluções digitais de ponta a ponta para gestão de estoque, rastreamento de remessas em tempo real e documentação automatizada.",
			time_and_cost_savings: "Economiza tempo e custos.",
		},
		$content: {
			$text: {
				0: "Acompanhe todos os seus envios em um só lugar e controle suas finanças com relatórios dinâmicos.",
				1: "Compartilhe suas atualizações em tempo real com seus clientes para melhorar a qualidade do seu serviço.",
				2: "Veja e compartilhe todos os documentos relacionados ao seu envio em um único sistema.",
				3: "Controle facilmente seu processo acessando o Antrego de todos os dispositivos e locais.",
				4: "Armazene todos os seus dados usando a tecnologia de criptografia SHA-256. Tenha tranquilidade quanto à segurança.",
				5: "Engaje no rastreamento conjunto com todos os stakeholders no processo empresarial. Gerencie o processo de forma mais eficiente.",
			},
			$title: {
				0: "Gestão de Remessas de Ponta a Ponta",
				1: "Comunicação com o Cliente em Tempo Real",
				2: "Gestão Centralizada de Documentos",
				3: "Acesso em Nuvem de Qualquer Lugar",
				4: "Segurança em Nível Corporativo",
				5: "Colaboração entre Múltiplas Partes",
			},
			content_title: "Tudo o que Você Precisa em Uma Plataforma",
		},
		$home: {
			subtitle: "Gerencie estoque, remessas, documentos e rastreamento em uma plataforma poderosa",
			text: "Economize 40% do tempo operacional com fluxos de trabalho automatizados. Junte-se a mais de 500 empresas que simplificam suas operações logísticas globalmente.",
			title: "Plataforma Logística Completa: Do Estoque à Entrega",
		},
		$lifecycle: {
			headline: "Processo",
			info_button: "Obter Informações",
			lifecycle_texts: {
				0: "Carregue arquivos adicionais para criar sua fatura proforma e compartilhe-a instantaneamente com seu cliente.",
				1: "Insira os detalhes do seu envio e adicione documentos. Notifique o seu cliente e gerencie todos os processos de envio de forma conjunta através de um único canal.",
				2: "Acompanhe sua situação financeira relacionada a importação e exportação em tempo real.",
			},
			lifecycle_titles: {
				0: "Faça login e crie uma fatura proforma",
				1: "Crie Envio",
				2: "Acompanhe Atividades Financeiras",
			},
			productivity_title: "Aumente a produtividade e reduza a complexidade e erros em 3 etapas.",
			tracking_guide_title: "Guia de Rastreamento Fácil",
		},
		$logistics: {
			logistics_title: "Tipos de Logística Suportados",
			solutions_title: "A solução certa para cada carga",
			text: "Com o Antrego, seu parceiro digital em todos os tipos de transporte, estamos ao seu lado em todos os seus movimentos globais.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Criação Profissional de Documentos PDF",
				hero_subtitle: "Crie documentos comerciais incríveis em minutos",
				hero_description:
					"O criador de PDFs intuitivo da Antrego permite projetar, personalizar e gerar faturas, faturas proforma e documentos comerciais profissionais com facilidade. Sem necessidade de habilidades de design.",
				features_title: "Tudo o que Você Precisa para Criar Documentos Profissionais",
				feature_1_title: "Editor de Arrastar e Soltar",
				feature_1_desc:
					"Interface intuitiva que permite adicionar textos, imagens, logotipos e tabelas com simples ações de arrastar e soltar. Sem habilidades técnicas.",
				feature_2_title: "Modelos Personalizados",
				feature_2_desc:
					"Escolha entre modelos pré-desenhados ou crie seus próprios layouts com a sua marca. Salve modelos para manter a consistência.",
				feature_3_title: "Campos de Formulário Inteligentes",
				feature_3_desc:
					"Preencha automaticamente informações do cliente, detalhes de produtos e preços. Conecte-se diretamente aos dados de remessas e estoque.",
				feature_4_title: "Personalização de Marca",
				feature_4_desc:
					"Adicione o logotipo da sua empresa, escolha cores da marca, personalize fontes e crie documentos que representem sua identidade.",
				feature_5_title: "Exportação em Múltiplos Formatos",
				feature_5_desc:
					"Baixe em PDF, imprima diretamente ou compartilhe por e-mail. Todos os documentos são formatados profissionalmente e prontos para impressão.",
				feature_6_title: "Controle de Versões",
				feature_6_desc:
					"Acompanhe revisões, mantenha o histórico e acesse versões anteriores. Nunca perca iterações importantes.",
				benefits_title: "Por que Escolher o Criador de PDF da Antrego?",
				benefit_1: "Crie documentos profissionais 10x mais rápido do que métodos tradicionais",
				benefit_2: "Mantenha a consistência da marca em todos os seus documentos comerciais",
				benefit_3: "Reduza erros com preenchimento automático de dados das suas remessas",
				benefit_4: "Economize tempo com modelos reutilizáveis e formulários inteligentes",
				benefit_5: "Impressione clientes com documentos polidos e profissionais",
				benefit_6: "Acesse seus documentos em qualquer lugar, a qualquer hora e em qualquer dispositivo",
				workflow_title: "Como Funciona a Criação de PDF",
				step_1_title: "Escolha o Modelo",
				step_1_desc:
					"Selecione entre modelos pré-desenhados ou comece com uma tela em branco para criar seu layout personalizado.",
				step_2_title: "Personalize o Conteúdo",
				step_2_desc:
					"Arraste e solte elementos, adicione seu logotipo e identidade visual, preencha campos automaticamente com dados de remessa.",
				step_3_title: "Pré-visualize e Edite",
				step_3_desc:
					"Revise seu documento em tempo real, faça ajustes e garanta que tudo esteja perfeito antes de gerar.",
				step_4_title: "Gere e Compartilhe",
				step_4_desc:
					"Baixe como PDF, envie por e-mail diretamente aos clientes ou anexe às remessas. Salve o modelo para uso futuro.",
				cta_title: "Comece a criar documentos profissionais hoje",
				cta_button: "Começar Grátis",
				cta_subtitle: "Não é necessário cartão de crédito • Comece em minutos",
			},
			description:
				"Nosso editor de PDF é uma ferramenta poderosa que torna a criação e edição de faturas mais prática. Economize tempo e apresente documentos com aparência profissional aos seus parceiros de negócios.",
			features: {
				design: "Design de faturas: Adicione seu logotipo, ajuste as cores e personalize o formato da fatura.",
				edit: "Edição de documentos: Edite rapidamente PDFs, adicione ou remova texto.",
				shareSave:
					"Compartilhar e salvar: Baixe, compartilhe ou armazene os documentos criados diretamente na plataforma.",
			},
			longTitle: "Faturas rápidas e personalizadas com o editor PDF.",
			note: "Essa configuração permite que os usuários explorem os recursos visualmente e revisem as vantagens por escrito.",
			title: "Criar faturas é muito fácil!",
		},
		$process: {
			comparison_subtitle: "Veja a diferença entre a gestão logística tradicional e a digital",
			digital_future: "Afaste-se dos métodos tradicionais e entre no futuro digital",
			digital_shipping: "Rastreamento Digital de Envio com Antrego",
			digital_shipping_texts: {
				0: "As faturas proforma para pedidos recebidos são criadas e rastreadas facilmente através de um único canal.",
				1: "As faturas proforma são enviadas, notificações vão para o cliente instantaneamente e são aprovadas através do Antrego.",
				2: "Os processos de documentos são gerenciados através do Antrego. Eles não são perdidos, não ocorrem atrasos e o potencial de erros é minimizado.",
				3: "Fornecedores, clientes e corretores de alfândega podem ver instantaneamente os detalhes de envio e rastreá-los em conjunto.",
				4: "Relatórios financeiros são gerados automaticamente mensal e anualmente.",
			},
			question_title: "Como a Antrego Economiza 10+ Horas por Semana",
			tracking_method: "Digitalize seus métodos de rastreamento e acelere seus processos.",
			traditional_shipping: "Rastreamento Tradicional de Envio",
			traditional_shipping_texts: {
				0: "Os pedidos são coletados via e-mail, mensagens ou telefone por diferentes canais, causando dificuldades de rastreamento interno.",
				1: "A fatura proforma é criada usando ferramentas como Excel, e o processo de aprovação é tratado manualmente por e-mail, WhatsApp ou telefone.",
				2: "Os processos manuais de documentos levam a erros e atrasos, causando perdas de tempo e financeiras.",
				3: "Não há uma plataforma comum para fornecedores, clientes e corretores de alfândega rastrearem os detalhes de envio.",
				4: "Os dados financeiros são verificados individualmente após cada envio, dificultando o relatório.",
			},
		},
		$question: {
			$text: {
				0: "<p>A Antrego é uma plataforma abrangente de gestão logística que ajuda empresas a rastrear remessas, gerenciar estoque e colaborar com clientes em tempo real. Ela digitaliza todo o processo da cadeia de suprimentos do estoque à entrega.</p>",
				1: "<p>A Antrego simplifica a logística com Acesso Fácil a partir de qualquer dispositivo, Segurança de Dados em nível corporativo usando criptografia SHA-256 e Rastreamento Conjunto que mantém todas as partes informadas ao longo do processo.</p>",
				2: "<p>A Antrego suporta todos os principais modos de transporte, incluindo transporte marítimo, carga aérea, transporte terrestre e logística ferroviária. Trabalhamos com os principais transportadores e linhas de navegação do mundo.</p>",
				3: "<p>A Antrego oferece um plano gratuito para até 10 remessas por mês sem necessidade de cartão de crédito. Os planos Premium começam em US$ 99/mês para remessas ilimitadas, com faturamento anual economizando 16%. Veja nossa página de preços para mais detalhes.</p>",
				4: "<p>Atualmente estamos desenvolvendo acesso por API e recursos de integração com sistemas populares de logística e ERP. As integrações estão planejadas para versões futuras. Entre em contato para saber mais sobre nosso roadmap e próximos recursos.</p>",
				5: "<p>Na maioria das empresas, tudo fica em funcionamento em até 24 horas. A configuração básica leva apenas 5–10 minutos para criar sua conta e adicionar as informações da empresa. Nossa equipe de implantação ajuda a importar dados e personalizar fluxos de trabalho.</p>",
			},
			$title: {
				0: "O que é a Antrego?",
				1: "Por que devo usar a Antrego?",
				2: "Quais tipos de logística a Antrego suporta?",
				3: "Quanto custa a Antrego?",
				4: "Posso integrar a Antrego com meus sistemas existentes?",
				5: "Quanto tempo leva para configurar a Antrego?",
			},
			save_percentage: "Economize 16% Mensalmente",
			text: "Acesse facilmente todas as informações com o Antrego e sinta-se à vontade para nos contatar para outras perguntas que possa ter.",
			title: "Saiba rapidamente o que você está curioso",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Transforme Sua Gestão de Estoque",
				hero_subtitle: "Do estoque às vendas — gerencie todo o ciclo de vida do produto digitalmente",
				hero_description:
					"O recurso de Gestão de Estoque da Antrego capacita exportadores e fabricantes a gerenciar inventário com eficiência, compartilhar catálogos de produtos com clientes e acelerar o processo de vendas em uma única plataforma integrada.",
				features_title: "Poderosos Recursos de Gestão de Estoque",
				feature_1_title: "Gestão Centralizada de Inventário",
				feature_1_desc:
					"Gerencie todos os itens de estoque a partir de um único painel. Acompanhe quantidades, lotes, armazéns e detalhes de produtos com facilidade.",
				feature_2_title: "Catálogo Público de Estoque",
				feature_2_desc:
					"Crie uma página pública para apresentar seus produtos disponíveis a potenciais clientes no mundo todo. Compartilhe seu inventário com um link simples.",
				feature_3_title: "Rastreamento por Lote",
				feature_3_desc:
					"Acompanhe lotes individuais com informações detalhadas, incluindo quantidades, dimensões e atributos personalizados para uma gestão precisa.",
				feature_4_title: "Suporte a Múltiplos Armazéns",
				feature_4_desc:
					"Organize seu inventário em vários armazéns e locais. Saiba onde cada produto está armazenado para logística eficiente.",
				feature_5_title: "Galeria de Imagens do Produto",
				feature_5_desc:
					"Envie várias imagens para cada item de estoque para oferecer clareza visual a seus clientes e membros da equipe.",
				feature_6_title: "Direto para Remessa",
				feature_6_desc:
					"Converta itens de estoque em remessas sem atritos. Crie faturas proforma e documentos de remessa diretamente do inventário.",
				benefits_title: "Por que Escolher a Antrego para Gestão de Estoque?",
				benefit_1: "Aumente a visibilidade dos seus produtos para compradores globais",
				benefit_2: "Reduza o tempo gasto no controle manual de inventário",
				benefit_3: "Simplifique a transição do estoque para as vendas",
				benefit_4: "Forneça informações de estoque em tempo real aos clientes",
				benefit_5: "Suporte a mais de 15 idiomas para alcançar mercados internacionais",
				benefit_6: "Integração com sistemas de remessa e faturamento",
				workflow_title: "Como Funciona",
				step_1_title: "Adicione Seus Produtos",
				step_1_desc:
					"Crie itens de estoque com informações detalhadas, incluindo dados do produto, quantidades, armazéns e imagens.",
				step_2_title: "Compartilhe Seu Catálogo",
				step_2_desc:
					"Gere um link público para o seu catálogo de estoque que potenciais clientes podem visualizar a qualquer momento.",
				step_3_title: "Receba Consultas",
				step_3_desc:
					"Os clientes podem visualizar seus produtos disponíveis e entrar em contato diretamente para pedidos e cotações.",
				step_4_title: "Converta em Vendas",
				step_4_desc:
					"Crie facilmente faturas proforma e remessas a partir dos itens de estoque para atender aos pedidos dos clientes.",
				cta_title: "Pronto para modernizar sua gestão de inventário?",
				cta_button: "Começar Grátis",
				cta_subtitle: "Não é necessário cartão de crédito • Configuração em minutos",
			},
			access_potential_customers: "Acesse rapidamente clientes potenciais",
			desc: "Especialmente desenvolvido para exportadores e fabricantes, Antrego acelera seus processos de vendas e marketing. Expanda seu negócio com gestão de estoque, compartilhamento de estoque com clientes e gestão de remessas!",
			global_market: "Conquiste o mercado global com suporte para 15 idiomas diferentes",
			main_title: "A solução de próxima geração para vendas e marketing",
			manage_stocks: "Gerencie e compartilhe seus estoques instantaneamente",
			speed_up_sales: "Acelere os processos de vendas",
			title: "Do Estoque à Venda",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Rastreamento de Remessas em Tempo Real",
				hero_subtitle: "Monitore cada contêiner, em cada etapa",
				hero_description:
					"O sistema avançado de rastreamento da Antrego oferece visibilidade total das suas remessas com atualizações em tempo real, notificações automatizadas e relatórios completos de status. Nunca mais perca o rastro dos seus contêineres.",
				features_title: "Solução Completa de Rastreamento",
				feature_1_title: "Rastreamento de Contêineres ao Vivo",
				feature_1_desc:
					"Acompanhe seus contêineres em tempo real com atualizações de localização precisas e estimativas de chegada para cada remessa.",
				feature_2_title: "Notificações Automatizadas",
				feature_2_desc:
					"Receba alertas instantâneos para marcos importantes: carregamento, partida, chegada, desembaraço aduaneiro e status de entrega.",
				feature_3_title: "Histórico de Status",
				feature_3_desc:
					"Acesse o histórico completo das remessas com registros detalhados de todos os movimentos, mudanças de status e eventos-chave.",
				feature_4_title: "Visibilidade para Múltiplas Partes",
				feature_4_desc:
					"Compartilhe informações de rastreamento com clientes, fornecedores e despachantes aduaneiros. Todos permanecem informados automaticamente.",
				feature_5_title: "Gestão de Documentos",
				feature_5_desc:
					"Anexe e acesse todos os documentos da remessa, incluindo conhecimentos de embarque, formulários aduaneiros e certificados, em um só lugar.",
				feature_6_title: "Alertas de Atraso",
				feature_6_desc:
					"Receba notificações proativas sobre possíveis atrasos ou problemas para agir antes que eles se agravem.",
				benefits_title: "Por que Escolher o Rastreamento da Antrego?",
				benefit_1: "Reduza consultas de clientes com acesso de autoatendimento ao rastreamento",
				benefit_2: "Previna atrasos onerosos com monitoramento e alertas proativos",
				benefit_3: "Melhore a satisfação do cliente com comunicação transparente",
				benefit_4: "Economize tempo com atualizações automáticas de status para todas as partes",
				benefit_5: "Minimize riscos com visibilidade em tempo real do status das remessas",
				benefit_6: "Páginas de rastreamento profissionais que valorizam sua marca",
				workflow_title: "Como Funciona o Rastreamento",
				step_1_title: "Criar Remessa",
				step_1_desc: "Insira detalhes da remessa, incluindo números de contêiner, rotas e datas previstas no sistema.",
				step_2_title: "Atualizações Automatizadas",
				step_2_desc:
					"O sistema rastreia contêineres automaticamente e atualiza o status conforme avançam em cada etapa.",
				step_3_title: "Notificações às Partes Envolvidas",
				step_3_desc: "Todos recebem notificações instantâneas sobre marcos importantes e mudanças de status.",
				step_4_title: "Confirmação de Entrega",
				step_4_desc: "Obtenha confirmação final de entrega com documentação completa e histórico da remessa.",
				cta_title: "Comece a rastrear suas remessas com confiança",
				cta_button: "Começar Grátis",
				cta_subtitle: "Não é necessário cartão de crédito • Comece a rastrear hoje",
			},
			control_title: "Assuma o controle de suas remessas com o Antrego.",
			real_time_alerts:
				"Alertas em tempo real: Receba notificações instantâneas e atualizações abrangentes sobre o status de cada contêiner.",
			secure_data_handling:
				"Manipulação segura de dados: Baixe, compartilhe ou armazene facilmente os dados de suas remessas diretamente na plataforma.",
			tracking_description:
				"A solução de rastreamento de contêineres da Antrego oferece uma maneira rápida e eficiente de monitorar suas remessas em tempo real. Mantenha o controle e impressione seus parceiros com atualizações detalhadas e profissionais.",
			tracking_title: "Rastreie suas remessas com facilidade!",
		},
		cancel_anytime: "Cancele a qualquer momento",
		customize_package:
			"Você pode adquirir armazenamento adicional e usuários e personalizar seu pacote de acordo com suas necessidades",
		free_features_1: "10 Envios",
		free_features_2: "100 MB de Armazenamento",
		free_features_3: "Parceiros Comerciais Ilimitados",
		free_features_4: "1 Usuário",
		free_plan: "Grátis",
		free_price: "$0",
		free_regeneration: "",
		free_title: "Mensal",
		premium_annual_features_1: "20 Usuários",
		premium_annual_features_2: "100 Parceiros",
		premium_annual_features_3: "1000 Envios",
		premium_annual_features_4: "1000 Faturas",
		premium_annual_price: "$83,25",
		premium_annual_regeneration: "Renovará anualmente por $999",
		premium_annual_title: "Anual",
		premium_monthly_features_1: "Envios Ilimitados",
		premium_monthly_features_2: "Parceiros Comerciais Ilimitados",
		premium_monthly_features_3: "2GB de Armazenamento",
		premium_monthly_features_4: "3 Usuários",
		premium_monthly_price: "$99",
		premium_monthly_regeneration: "Renovará mensalmente por $99",
		premium_monthly_title: "Mensal",
		premium_plan: "Plano Premium",
		premium_plus_annual_features_1: "Envios Ilimitados",
		premium_plus_annual_features_2: "Parceiros Comerciais Ilimitados",
		premium_plus_annual_features_3: "5GB de Armazenamento",
		premium_plus_annual_features_4: "5 Usuários",
		premium_plus_annual_price: "$83,25",
		premium_plus_annual_regeneration: "Renovará anualmente por $999",
		premium_plus_annual_title: "Anual",
		premium_plus_monthly_features_1: "Envios Ilimitados",
		premium_plus_monthly_features_2: "Parceiros Comerciais Ilimitados",
		premium_plus_monthly_features_3: "5GB de Armazenamento",
		premium_plus_monthly_features_4: "5 Usuários",
		premium_plus_monthly_price: "$249",
		premium_plus_monthly_regeneration: "Renovará mensalmente por $249",
		premium_plus_monthly_title: "Mensal",
		premium_plus_plan: "Premium Plus",
		pricing_text: "Podemos atender às suas necessidades da melhor forma sem ultrapassar o seu orçamento.",
		pricing_title: "O Antrego garante oferecer o melhor pacote e preço para você.",
		save_percentage: "Economize 16% Mensalmente",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Árabe",
		de: "Alemão",
		en: "Inglês",
		es: "Espanhol",
		fr: "Francês",
		hi: "Hindi",
		ind: "Indonésio",
		it: "Italiano",
		ja: "Japonês",
		ko: "Coreano",
		pt: "Português",
		ru: "Russo",
		tr: "Turco",
		vi: "Vietnamita",
		zh: "Chinês",
	},
	$message: {
		cannot_delete_verified_partner: "Você não pode excluir um parceiro verificado.",
		confirm: "Você tem certeza de {function}?",
		created: "{item} criado.",
		deleted: "{item} excluído.",
		edited: "{item} editado.",
		error_on_view_file: "Ocorreu um erro ao visualizar o arquivo.",
		file_oversize: "O tamanho do arquivo deve ser no máximo {size}.",
		invalid: "{item} inválido",
		migrated: "{item} migrado. ({value})",
		process_has_been_started: "Seu {item} foi iniciado.",
		saved: "{item} salvo.",
		sent: "{item} enviado.",
		sent_email: "E-mail enviado. ({value})",
		sign_in_failed: "E-mail ou senha incorretos",
		unsupported_file_type: "Tipo de arquivo não suportado",
		updated: "{item} atualizado.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - Plataforma completa de gestão logística para exportadores, importadores e agentes de carga. Rastreie remessas em tempo real, gerencie estoque, crie faturas e automatize documentação. Economize 40% do tempo com soluções logísticas digitais. Experimente grátis!",
		stock_feature:
			"Transforme sua gestão de estoque com a Antrego. Gerencie inventário, crie catálogos públicos, rastreie lotes entre armazéns e converta estoque em remessas instantaneamente. Ideal para exportadores e fabricantes.",
		tracking_feature:
			"Rastreamento em tempo real de contêineres e remessas com a Antrego. Monitore cada contêiner com atualizações ao vivo, notificações automatizadas, histórico completo de status e visibilidade para múltiplas partes. Nunca perca o rastro das suas remessas.",
		pdf_feature:
			"Criador profissional de documentos PDF para logística. Projete faturas e faturas proforma personalizadas com editor de arrastar e soltar, modelos e preenchimento automático de dados. Crie documentos incríveis em minutos.",
		benefits_feature:
			"Conheça os benefícios da plataforma Antrego. Painel centralizado, maior precisão, eficiência de tempo, colaboração da equipe, redução de custos e escalabilidade. Transforme suas operações logísticas hoje.",
		contact:
			"Contato Antrego - Fale com nossa equipe para dúvidas, demonstrações ou suporte. Estamos aqui para ajudar a transformar suas operações logísticas.",
		sign_in:
			"Entrar na Antrego - Acesse seu painel logístico para gerenciar remessas, rastrear contêineres, criar faturas e colaborar com sua equipe. Portal de login seguro.",
		sign_up:
			"Cadastrar-se na Antrego - Crie sua conta gratuita para começar a gerenciar operações logísticas. Obtenha 10 remessas gratuitas por mês. Não é necessário cartão de crédito.",
	},
	$pageTitles: {
		accept_invitation: "Aceitar Convite",
		benefits_feature: "Benefícios da Plataforma - Solução Logística Completa",
		company_profile: "Perfil da Empresa",
		contact: "Fale Conosco - Entre em Contato com a Antrego",
		home: "Início",
		landing_page: "Gerencie Todos os Seus Processos de Envio Digitalmente",
		partners: "Parceiros",
		pdf_editor: "Editor de PDF",
		pdf_feature: "Criador de Documentos PDF - Faturas Profissionais",
		product_details: "Detalhes do Produto",
		product_groups: "Grupos de Produtos",
		products: "Produtos",
		proforma_invoices: "Faturas Proforma",
		shipment_details: "Detalhes do Envio",
		shipments: "Envios",
		sign_in: "Entrar",
		sign_up: "Inscrever-se",
		stock_details: "Detalhes do Estoque",
		stock_feature: "Gestão de Estoque - Transforme Seu Inventário",
		stocks: "Estoques",
		subscription: "Assinatura",
		tracking_feature: "Rastreamento de Remessas - Monitoramento de Contêineres em Tempo Real",
		user_profile: "Perfil do Usuário",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Parceiros não registrados, você criou o perfil deles em nossa plataforma, para que você possa visualizar e editar suas informações.",
		createdHereTitle: "Criado aqui:",
		description: "Você pode acompanhar o status da sua relação com seus parceiros. Aqui estão as diferenças:",
		verifiedPartnersDescription:
			"Esses parceiros aceitaram seu convite e se registraram na plataforma. Suas informações são apenas para visualização e não podem ser editadas.",
		verifiedPartnersTitle: "Parceiros verificados:",
	},
	$productGroup: {
		add_child: "Adicionar Subgrupo",
		add_new_product_group: "Adicionar novo grupo de produtos",
		add_to_root: "Adicionar à Raiz",
		has_children_fail_message: "Um grupo de produtos com um subgrupo não pode ser excluído",
		initial_message: "Use este botão {0} para criar seu primeiro grupo de produtos.",
		name: "Nome",
		number_of_product: "Número de produtos",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} aprovado.",
			create: "Criado por {name}.",
			create_attachment: "{name} criou um anexo.",
			delete_attachment: "{name} excluiu um anexo.",
			demand_revise: "{name} solicitou revisão.",
			mark_as_processed: "{name} marcado como processado.",
			reject: "{name} rejeitado.",
			revoke: "{name} revogado.",
			send: "{name} enviado ao receptor para avaliação.",
			update: "Atualizado por {name}.",
			update_attachment: "{name} atualizou um anexo.",
		},
		$actions: {
			approve: "Aprovar",
			demand_revise: "Solicitar Revisão",
			mark_as_approved: "Aprovado",
			mark_as_processed: "Processado",
			mark_as_rejected: "Rejeitado",
			mark_as_revise_demanded: "Revisão Solicitada",
			mark_as_revoked: "Revogado",
			mark_as_sent: "Enviado",
			reject: "Rejeitar",
			revoke: "Revogar",
			send: "Enviar",
		},
		$status: {
			approved: "Aprovado",
			pending_approval: "Aguardando Aprovação",
			pending_revise: "Revisão Pendente",
			processed: "Processado",
			rejected: "Rejeitado",
			revoked: "Revogado",
			template: "Modelo",
		},
		approve_confirm_message: "Tem certeza de que deseja aprovar a fatura proforma?",
		approve_success_message: "A fatura proforma foi aprovada.",
		demand_revise_description_message: "Por favor, forneça alguns detalhes sobre sua expectativa de revisão:",
		demand_revise_success_message: "A fatura proforma foi enviada de volta ao remetente para revisão.",
		mark_as_processed_confirm_message: "Você confirma marcar a fatura proforma como processada?",
		mark_as_processed_success_message: "A fatura proforma foi marcada como processada.",
		no_attachment_text: "Nenhum anexo adicionado ainda.",
		reject_confirm_message: "Tem certeza de que deseja rejeitar a fatura proforma?",
		reject_success_message: "A fatura proforma foi rejeitada.",
		revoke_confirm_message: "Tem certeza de que deseja revogar a fatura proforma?",
		revoke_success_message: "A fatura proforma foi revogada.",
		send_confirm_message: "Você confirma o envio da fatura proforma ao receptor?",
		send_success_message: "A fatura proforma foi enviada.",
	},
	$seoTitles: {
		landing_page: "Antrego | Software de Gestão Logística - Rastrear, Gerenciar, Automatizar",
		stock_feature: "Software de Gestão de Inventário | Sistema de Rastreamento de Estoque | Antrego",
		tracking_feature: "Software de Rastreamento de Remessas em Tempo Real | Rastreamento de Contêineres | Antrego",
		pdf_feature: "Gerador de Fatura Proforma | Editor de PDF para Logística | Antrego",
		benefits_feature: "Benefícios da Plataforma Logística Completa | Solução Tudo-em-Um | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "Já existe uma assinatura para este módulo.",
		bad_request: "Requisição Inválida",
		code_already_used: "O código já foi usado.",
		container_status_not_available: "O status do contêiner não está disponível.",
		existing_email_warning: "O e-mail já existe.",
		existing_employee_error: "Este usuário já foi adicionado à sua empresa.",
		existing_employee_for_email_warning: "O código de convite já foi enviado para este e-mail",
		existing_invitation_warning: "O código de convite já foi enviado para este e-mail.",
		existing_token_already_have_time: "O token existente já tem tempo suficiente para ser usado.",
		existing_user: "O usuário já existe.",
		five_min_reset_password_mail:
			"Você deve esperar pelo menos 5 minutos depois de solicitar um e-mail de redefinição de senha uma vez.",
		forbidden: "Proibido",
		have_no_corporation: "Você não tem uma corporação",
		have_no_custom_agency: "Você não tem uma agência de alfândega",
		have_no_employee: "Você não tem funcionário",
		instance_can_no_delete_existing_booking_code:
			"A instância não pode mais ser excluída devido ao código de reserva existente.",
		instance_cannot_delete: "A instância não pode mais ser excluída.",
		instance_not_found: "Instância não encontrada.",
		internal_server_error: "Erro Interno do Servidor",
		invalid_current_password: "Senha atual inválida.",
		invalid_identifier_or_password: "Identificador ou senha inválidos",
		invalid_invitation_code: "O código do convite está incorreto.",
		invalid_moving_request: "Solicitação de movimento inválida",
		invalid_operation: "Operação inválida",
		invalid_refresh_token: "Token de atualização inválido.",
		invalid_unit: "Unidade inválida",
		invitation_accepting_is_due_to_the_admin: "A aceitação do convite é de responsabilidade do administrador.",
		invitation_already_discarded: "O convite já foi descartado.",
		invitation_already_used: "O convite já foi usado.",
		invitation_has_been_used: "O convite foi usado.",
		invitation_not_exist_email: "O convite não existe no endereço de e-mail.",
		invitation_not_for_company: "Este convite não é para uma empresa.",
		invitation_not_for_custom_agency: "Este convite não é para uma agência de alfândega.",
		invitation_not_found: "O convite não foi encontrado.",
		invitation_not_valid: "O convite não é mais válido.",
		link_has_been_expired: "O link expirou.",
		link_not_be_used_anymore: "Este link não pode mais ser usado",
		missing_required_fields: "Campos obrigatórios ausentes.",
		no_employee_found: "Nenhum funcionário encontrado",
		no_proper_partner_found: "Nenhum parceiro adequado encontrado.",
		not_acceptable: "Não Aceitável",
		not_allowed_action: "Você não tem permissão para essa ação.",
		not_allowed_use_api: "Você não tem permissão para usar essa API.",
		not_found: "Não Encontrado",
		not_have_purchase_subscription:
			"Seu plano de assinatura atingiu o limite máximo para definições. Para adicionar mais, considere atualizar seu plano de assinatura.",
		not_permitted_use_api: "Você não tem permissão para usar essa API.",
		own_invitation_cannot_accept: "Você não pode aceitar seu próprio convite.",
		parent_group_not_found: "Grupo Pai não encontrado",
		partnerId_required: "ID do Parceiro é necessário.",
		partnership_already_exists: "O parceiro já foi adicionado.",
		password_cant_involve_space_char: "A senha não pode conter espaços.",
		password_min_chars_least: "A senha deve ter no mínimo 6 caracteres.",
		payment_required: "Por favor, assine para este processo.",
		paytr_integration_error: "Erro na integração com PayTR",
		ports_are_required: "Portos são necessários.",
		product_group_tree_not_found: "Árvore do Grupo de Produtos não encontrada",
		proforma_invoice_action_not_available: "O status da fatura proforma não está disponível para esta ação.",
		proforma_invoice_template_update: "A fatura proforma deve ser um modelo para ser atualizada.",
		shipment_email_not_exist: "Por favor, insira um e-mail válido.",
		shipment_method_is_required: "O método de envio é necessário.",
		shipping_term_is_required: "O termo de envio é necessário.",
		someone_else_uses_this_email: "Alguém mais está usando este endereço de e-mail.",
		someone_else_uses_this_username: "Alguém mais está usando este nome de usuário.",
		something_went_wrong: "Algo deu errado",
		type_can_be_abstract_company: 'A propriedade "tipo" só pode ser "abstract_company"',
		unauthorized: "Não Autorizado",
		undefined_result: "Resultado indefinido",
		unexpected_error_occurred: "Ocorreu um erro inesperado",
		unit_already_added: "A unidade já foi adicionada.",
		user_already_employee: "O usuário já é funcionário.",
		user_already_exists: "O usuário já existe em uma empresa.",
		user_does_not_exist: "O usuário não existe.",
		user_not_found: "Usuário não encontrado.",
		username_min_chars_error: 'O "nome de usuário" deve ter no mínimo 6 caracteres.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} adicionou um veículo.",
				delete_container: "{name} excluiu um veículo.",
				update_container: "{name} atualizou um veículo.",
			},
			create: "Criado por {name}.",
			create_attachment: "{name} adicionou um anexo.",
			create_container: "{name} adicionou um contêiner.",
			delete_attachment: "{name} excluiu um anexo.",
			delete_container: "{name} excluiu um contêiner.",
			update: "Atualizado por {name}.",
			update_attachment: "{name} atualizou um anexo.",
			update_container: "{name} atualizou um contêiner.",
		},
		$containerStatus: {
			arrived: "Chegou",
			off_load: "Descarregando",
			on_load: "Carregando",
			on_way: "A Caminho",
			reserved: "Reservado",
		},
		$method: {
			aerial: "Aéreo",
			land: "Terrestre",
			railway: "Ferroviário",
			sea: "Marítimo",
		},
		$vehicle: {
			license_number: "Placa do Veículo",
		},
		archiving_success_message: "O envio foi arquivado.",
		leave_message: "Deixe sua mensagem ou comentário",
		no_booking_info: "Nenhuma informação de reserva foi definida ainda. Use o botão {0} para adicionar.",
		no_transportation_info: "Nenhuma informação de transporte foi definida ainda. Use o botão {0} para definir.",
		un_archiving_success_message: "O envio foi desarquivado.",
	},
	$shortening: {
		number: "Nº",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "Sua assinatura não pôde ser renovada. Verifique seu método de pagamento.",
			fail: "Ocorreu um erro inesperado. Tente novamente mais tarde. Se o problema persistir, por favor, reporte enviando um e-mail para info@antrego.net.",
			ok: "O processo de compra foi iniciado. O resultado do processo será notificado por e-mail. Sua assinatura será iniciada quando o pagamento for concluído com sucesso.",
			payment_process_is_ongoing:
				"Seu processo de pagamento está em andamento. O resultado do processo será notificado por e-mail. Sua assinatura será iniciada quando o pagamento for concluído com sucesso.",
			success: "Sua assinatura foi criada com sucesso. Você pode começar a usar o Antrego facilmente.",
			try_to_get_paid_again: "Sua assinatura expirou. Clique aqui para renovar.",
			unsubscribed: "Cancelado",
			you_dont_have_any_subscription:
				"Você não tem nenhuma assinatura. Escolha um pacote na página de assinatura e comece a usá-lo facilmente.",
			you_dont_have_any_subscription_text: "Escolha um plano para continuar.",
			you_dont_have_any_subscription_title: "Você não tem nenhuma assinatura ativa.",
		},
	},
	$unit: {
		acres: "Acres",
		boxes: "Caixas",
		centimeter: "Centímetro",
		cubic_meter: "Metro Cúbico",
		dozen: "Dúzia",
		feet: "Pés",
		fluid_ounces: "Onças Líquidas",
		gallons: "Galões",
		gram: "Grama",
		hectare: "Hectare",
		inches: "Polegadas",
		kilogram: "Quilograma",
		kilometer: "Quilômetro",
		liter: "Litro",
		meter: "Metro",
		miles: "Milhas",
		milligram: "Miligrama",
		milliliter: "Mililitro",
		millimeter: "Milímetro",
		ounces: "Onças",
		pallets: "Paletes",
		pieces: "Peças",
		pounds: "Libras",
		quarts: "Quartos",
		square_feet: "Pés Quadrados",
		square_inches: "Polegadas Quadradas",
		square_kilometer: "Quilômetro Quadrado",
		square_meter: "Metro Quadrado",
		square_miles: "Milhas Quadradas",
		square_yards: "Jardas Quadradas",
		ton: "Toneladas",
		yards: "Jardas",
	},
	$validation: {
		email: "Por favor, insira um e-mail válido",
		invalid: "{item} inválido",
		max_length: "{item} deve ter menos de {length} caracteres",
		min_length: "{item} deve ter mais de {length} caracteres",
		must_length: "{item} deve ter {length} caracteres",
		only_number: "{item} deve ser um número",
		password_repeat_warning: "A repetição da senha não é igual à nova senha.",
		required: "{item} é obrigatório",
		required_for_default_language: "{item} é obrigatório para o idioma padrão da empresa.",
		you_must_approve_distance_sales_agreement: "Você deve aprovar o Contrato de Vendas à Distância",
	},
	about: "Sobre",
	accept_invitation: "Aceitar Convite",
	accept_invitation_success_message: "Você utilizou o convite com sucesso.",
	accessibility: "acessibilidade",
	actions: "Ações",
	active: "Ativo",
	activities: "Atividades",
	add: "Adicionar",
	add_attribute: "Adicionar Atributo",
	add_from_stock: "Adicionar do estoque",
	add_images: "Adicionar Imagem",
	add_item: "Adicionar {item}",
	add_manually: "Criar aqui",
	add_new_employee: "Adicionar novo funcionário",
	add_new_packaging: "Adicionar nova embalagem",
	add_new_product: "Adicionar novo produto",
	add_new_stock: "Adicionar Novo Estoque",
	add_new_warehouse: "Adicionar Novo Armazém",
	add_stock_batch: "Adicionar Lote de Estoque",
	add_template: "Adicionar Modelo",
	add_variant: "Adicionar Variante",
	address: "Endereço",
	again: "Novamente",
	alert: "Alerta",
	already_have_employee_message: "Você já é um funcionário de uma empresa.",
	amount: "Quantia",
	approve: "Aprovar",
	archive: "Arquivar",
	attachment: "Anexo",
	attachments: "Anexos",
	attribute: "Atributo",
	attributes: "Atributos",
	auto_attached_pdf: "PDF anexado automaticamente",
	auto_detect: "Detecção automática",
	available: "Disponível",
	bank: "Banco",
	basket: "Carrinho",
	basket_empty: "Seu carrinho está vazio",
	batch: "Lote",
	batch_no: "Número do Lote",
	batches: "Lotes De Estoque",
	benefits: "Benefícios",
	billed_to: "Faturado para",
	booking: "Reserva",
	booking_code: "Código de Reserva",
	booking_details: "Detalhes da Reserva",
	boolean: "Booleano",
	business_partner: "Parceiro Comercial",
	business_partners: "Parceiros Comerciais",
	cancel: "Cancelar",
	carrier: "Transportadora",
	change_password: "Alterar Senha",
	checking_invitation_code_message: "Verificando o código de convite",
	checkout: "Finalizar Compra",
	choose_image: "Escolher imagem",
	choose_your_plan: "Escolha seu plano",
	clear: "Limpar",
	clear_basket: "Esvaziar Carrinho",
	click_to_play_the_video: "Clique para reproduzir o vídeo",
	close: "Fechar",
	code: "Código",
	commercial: "Comercial",
	commercial_partner: "Parceiro Comercial",
	commercial_partners: "Parceiros Comerciais",
	companies: "Empresas",
	company: "Empresa",
	company_address: "Endereço da empresa",
	company_name: "Nome da empresa",
	company_profile: "Perfil da Empresa",
	configuration: "Configuração",
	confirm: "Confirmar",
	confirm_distance_selling_agreement: "Confirme o Contrato de Vendas à Distância.",
	consult_us: "Consulte-nos",
	contact: "Contato",
	contact_info: "Informações de Contato",
	contact_text: "Fique tranquilo, entraremos em contato com você o mais rápido possível.",
	contact_title: "Consulte-nos, simplifique seus processos",
	contact_to_us: "Contate-nos",
	container: "Contêiner",
	container_no: "N.º do Contêiner",
	containers: "Contêineres",
	content: "Conteúdo",
	contract: "Contrato",
	copy_link: "Copiar link",
	corporation: "Empresa",
	countries: "Países",
	country: "País",
	create: "Criar",
	create_a_new_account: "Criar uma Nova Conta",
	create_company: "Criar Empresa",
	create_document: "Criar Documento",
	create_shipment: "Criar envio",
	created_at: "Criado em",
	created_here: "Criado aqui",
	credit_card_info: "Informações do Cartão de Crédito",
	credit_card_no: "Número do Cartão de Crédito",
	currencies: "Moedas",
	currency: "Moeda",
	current_password: "Senha Atual",
	current_plan: "Plano atual",
	customer_company_address: "Endereço da empresa cliente",
	customer_company_name: "Nome da empresa cliente",
	customs: "Alfândega",
	customs_agencies: "Agências de Alfândega",
	customs_agency: "Agência de Alfândega",
	cvv: "CVV",
	daily: "Diário",
	damaged: "Danificado",
	dashboard: "Painel",
	date: "Data",
	date_input: "Entrada de data",
	day: "Dia",
	default: "Padrão",
	default_language: "Idioma Padrão",
	delete: "Excluir",
	delete_account: "Excluir conta",
	delete_confirm_message: "Você confirma a exclusão?",
	delete_document: "Excluir documento",
	delete_template: "Excluir modelo",
	description: "Descrição",
	detail: "Detalhe",
	dimensions: "Dimensões",
	discard: "Descartar",
	discover_all_benefits: "Descubra Todos os Benefícios",
	distance_sales_agreement: "Contrato de Vendas à Distância",
	document: "Documento",
	document_actions: "Ações do documento",
	document_added: "Documento adicionado",
	document_creator: "Criador de Documentos",
	document_manager: "Gerenciador de documentos",
	document_name: "Nome do documento",
	document_number: "Número do Documento",
	document_overwrite: "Salvar edições como novo documento",
	document_save_info: "Este documento será salvo apenas dentro desta fatura proforma.",
	document_updated: "Documento atualizado",
	download: "Baixar",
	download_pdf: "Baixar PDF",
	download_template: "Baixar o modelo",
	edit: "Editar",
	edit_attribute: "Editar atributo",
	edit_description: "Editar descrição",
	edit_document: "Editar documento",
	edit_item: "Editar {item}",
	edit_packaging: "Editar embalagem",
	edit_product: "Editar produto",
	edit_profile: "Editar perfil",
	edit_stock: "Editar estoque",
	edit_stock_batch: "Editar Lote de Estoque",
	edit_template: "Editar modelo",
	edit_variant: "Editar Variante",
	edit_your_profile_picture: "Editar sua foto de perfil",
	email: "E-mail",
	employee: "Funcionário",
	employee_type: "Tipo de Funcionário",
	employees: "Funcionários",
	empty_data_warning: "Ainda não há dados nesta área. Você pode começar a explorar a plataforma com dados de exemplo.",
	estimated_arrival_day: "Data Estimada de Chegada",
	expense: "Despesa",
	expenses: "Despesas",
	expires_at: "Expira em",
	explore_pdf_editor: "Crie Documentos Instantaneamente",
	explore_stock_management: "Domine Seu Inventário",
	explore_tracking_features: "Rastreie em Tempo Real",
	exported_containers: "Contêineres Exportados",
	fail: "Falhar",
	failed: "Falhou",
	faq: "F.A.Q.",
	feedback: "Feedback",
	file: "Arquivo",
	file_name: "Nome do Arquivo",
	file_preview: "Pré-visualização do Arquivo",
	file_processing_error_message: "Erro ao processar o arquivo: {error}",
	file_read_error_message: "Erro ao ler o arquivo",
	file_view: "Visualizar Arquivo",
	filter: "Filtrar",
	first_name: "Nome",
	first_name_last_name: "Nome Sobrenome",
	fixed_value: "Valor fixo",
	forget_password: "Esqueceu a Senha",
	forget_password_message: "Esqueceu sua senha?",
	forget_password_subtitle: "Por favor, insira seu endereço de e-mail para redefinir sua senha.",
	format: "Formato",
	free: "Grátis",
	from: "De",
	general: "Padrão",
	get_started_now: "Comece agora",
	give_us_feedback: "Nos dê feedback",
	go_to_panel: "Ir para o Painel",
	go_to_proforma: "Ir para a proforma",
	go_to_shipment: "Ir para o envio",
	gross: "Bruto",
	height: "Altura",
	hide: "Ocultar",
	hide_all: "Ocultar Tudo",
	home_page: "Página Inicial",
	i_have_invitation_code: "Eu tenho um código de convite",
	image_delete: "Excluir imagem",
	images: "Imagens",
	import_excel: "Importar do Excel",
	import_fail_message: "Importação falhou: {error}",
	import_success_message: "Importação bem-sucedida de {count} produtos{skipped}.",
	imported_containers: "Contêineres Importados",
	in_progress: "Em Andamento",
	in_stock: "Em Estoque",
	incoming: "Entrante",
	incoming_shipments: "Envios Entrantes",
	initial: "Inicial",
	inputs: "Conteúdo",
	invitation: "Convite",
	invitation_code: "Código de Convite",
	invitation_mail_sent: "E-mail de convite enviado",
	invitations: "Convites",
	invoice: "Fatura",
	invoice_no: "Número da fatura",
	join: "Entrar",
	join_company: "Juntar-se à Empresa",
	language: "Idioma",
	language_options: "Opções de Idioma",
	last_name: "Sobrenome",
	last_one_year: "Último 1 Ano",
	latitude: "Latitude",
	learn_more: "Saiba Mais",
	left_a_comment: "Deixou um comentário",
	length: "Comprimento",
	link_copied: "Link copiado",
	link_copy_failed: "Falha ao copiar o link",
	loading_country: "Carregando País",
	loading_point: "Ponto de Carregamento",
	loading_port: "Porto de Carregamento",
	log_in: "Entrar",
	logo: "Logo",
	longitude: "Longitude",
	lot_no: "Número do Lote",
	mail_sent: "E-mail enviado",
	make_visible: "Tornar Visível",
	manage_profile: "Gerenciar perfil",
	mass: "Massa",
	measurements: "Medições",
	merge_partner_description:
		"A empresa criada aqui pode ser mesclada com o parceiro verificado existente quando criar um perfil no Antrego.",
	message: "Mensagem",
	message_company_create: "Empresa criada.",
	message_company_join: "Por favor, insira o código de convite.",
	message_company_joined: "Você entrou na empresa",
	message_employee_delete: "Funcionário excluído.",
	message_employee_save: "Funcionário salvo.",
	message_join_company: "Digite seu código para entrar em uma empresa existente",
	method: "Método",
	migrate: "Migrar",
	migrate_partner: "Migrar Empresa",
	migrate_partner_description:
		"A empresa criada aqui pode ser mesclada com o parceiro verificado existente quando criar um perfil no Antrego",
	missing_product_group_sheet_message: "Falta a planilha de Grupo de Produto no arquivo Excel",
	missing_product_sheet_message: "Falta a planilha de Produto no arquivo Excel",
	mobile_number: "Número de Celular",
	month: "Mês",
	month_lowercase: "mês",
	monthly: "Mensal",
	multiple_select: "Seleção Múltipla",
	my_profile: "Meu Perfil",
	my_role: "Meu Papel",
	name: "Nome",
	net: "Líquido",
	new: "Novo",
	new_company_package: "Grátis",
	new_password: "Nova Senha",
	new_shipment: "Nova remessa",
	next: "Próximo",
	no: "Não",
	no_content: "Sem Conteúdo",
	no_entity: "Nenhuma entidade",
	no_entity_message: "Nenhuma entidade encontrada.",
	no_image: "Imagem não encontrada",
	no_product_data_message: "Nenhum dado de produto encontrado no arquivo Excel",
	no_product_group_data_message: "Nenhum dado de grupo de produto encontrado no arquivo Excel",
	no_stock_batches_found: "Nenhum lote de estoque encontrado",
	no_stock_matches_filters: "Não há estoque que corresponda aos filtros selecionados.",
	no_stocks_added_yet: "Nenhum estoque foi adicionado ainda — por favor selecione ou adicione um.",
	no_text: "Sem Texto",
	no_valid_products_message:
		"Nenhum produto válido encontrado. Todos os produtos devem ter um nome no idioma padrão ({language}).",
	not_found_in_stock: "Não foi possível encontrar um produto em estoque com os filtros atuais.",
	not_found_page_message: "Desculpe, não consegui encontrar esta página :(",
	not_set: "Não definido",
	note: "Nota",
	notes: "Notas",
	number_of_rows: "Número de Linhas",
	ok: "OK",
	operation_fail: "Operação Falhou",
	option: "Opção",
	options: "Opções",
	other: "Outro",
	out_of_stock: "Fora De Estoque",
	outgoing: "Saída",
	outgoing_shipments: "Envios de Saída",
	packages: "Pacotes",
	packaging: "Embalagem",
	packing_list_title: "Lista de Embalagem",
	parent_group: "Grupo Pai",
	partner: "Parceiro",
	partners: "Parceiros",
	partnership_status: "Status da parceria",
	passive: "Passivo",
	password: "Senha",
	pay: "Pagar",
	payback: "Reembolso",
	payback_confirm_message: "Você confirma o reembolso?",
	payback_warning_message: "Se você continuar, sua assinatura será encerrada.",
	payment: "Pagamento",
	payment_amount: "Valor do Pagamento",
	payment_awaited: "Pagamento Aguardado",
	payment_history: "Histórico de Pagamento",
	payment_info: "Informações de pagamento",
	payment_information: "Informações de pagamento",
	payment_success: "Pagamento Concluído",
	payment_summary: "Resumo de Pagamento",
	payment_will_be_made_3d_secure: "*Seu pagamento será realizado com 3D Secure.",
	pdf_attached_message: "PDF anexado com sucesso",
	pdf_editor: "Editor de PDF",
	pdf_name: "Nome do PDF",
	pending_invitations: "Convites pendentes",
	per_month: "Por mês",
	phone_number: "Número de Telefone",
	pieces: "Peças",
	plate_numbers: "Números de Placa",
	please_click_add_option: "Você digitou uma opção mas não a adicionou. Por favor, adicione-a ou limpe-a.",
	prefix: "Prefixo",
	premium: "Premium",
	premium_plus: "Premium Plus",
	preview: "Pré-visualização",
	previous: "Anterior",
	price: "Preço",
	pricing: "Preços",
	process: "Processo",
	product: "Produto",
	product_details: "Detalhes do Produto",
	product_group: "Grupo de Produtos",
	product_group_name: "Nome do grupo de produtos",
	product_group_not_found_message:
		'Grupo de produto "{group}" não encontrado. Produto com código "{code}" será ignorado.',
	product_groups: "Grupos de Produtos",
	product_images: "Imagens do produto",
	product_name: "Nome do produto",
	products: "Produtos",
	profile: "Perfil",
	proforma_invoice: "Fatura Proforma",
	proforma_invoices: "Faturas Proforma",
	proforma_number: "Nº da Fatura Proforma",
	proforma_options: "Opções de Proforma",
	proforma_title: "Fatura Proforma",
	purchase: "Compra",
	quantity: "Quantidade",
	quantity_warning:
		"Como você alterou anteriormente o valor Total do Estoque, o total não será calculado automaticamente.",
	ready_to_import: "Pronto para importar",
	receiver: "Receptor",
	receiver_company: "Empresa Receptora",
	receiver_customs_agency: "Agência de Alfândega Receptora",
	redirection_to_home_link: "Início",
	redirection_to_home_message: "Você também pode ir para ",
	redirection_to_sign_in_message: "Já tem uma conta?",
	redirection_to_sign_up_message: "Ainda não tem uma conta?",
	reload: "Recarregar",
	renewal: "Renovação",
	repaid: "Reembolsado",
	reserved: "Reservado",
	reset_password: "Redefinir Senha",
	returned: "Devolvido",
	route: "Rota",
	rows_per_page: "Linhas por Página",
	sales: "Vendas",
	save: "Salvar",
	save_as_document: "Salvar como Documento",
	save_as_new_document: "Salvar como Novo Documento",
	save_as_new_template: "Salvar como Novo Modelo",
	save_as_template: "Salvar como Modelo",
	save_changes: "Salvar alterações",
	save_pdf_to_attachments: "Salvar PDF em Anexos",
	saved_card_info: "Informações do Cartão Salvas",
	search: "Pesquisar",
	select: "Selecionar",
	select_a_file_to_preview: "Selecione um arquivo para pré-visualizar",
	select_document: "Selecione o documento",
	select_document_to_overwrite: "Selecionar Documento para Sobrescrever",
	select_file: "Selecionar Arquivo",
	select_file_place_holder: "Por favor, selecione uma imagem",
	select_language: "Selecionar idioma",
	select_template: "Selecione o modelo",
	select_template_to_overwrite: "Selecionar Modelo para Sobrescrever",
	selected: "Selecionado",
	selected_partner: "Parceiro Selecionado",
	send: "Enviar",
	send_again: "Enviar Novamente",
	send_email: "Enviar E-mail",
	send_feedback: "Enviar Feedback",
	send_invitation: "Enviar Convite",
	sender: "Remetente",
	sender_company: "Empresa Remetente",
	sender_customs_agency: "Agência de Alfândega Remetente",
	separate_gross: "Adicionar medidas brutas",
	settings: "Configurações",
	shipment: "Envio",
	shipment_code: "Código de envio",
	shipment_details: "Detalhes do envio",
	shipment_method: "Método de Envio",
	shipment_type: "Tipo de Envio",
	shipments: "Envios",
	shipments_filter: "Filtro de Envios",
	shipped: "Enviado",
	shipping_term: "Termo de Envio",
	shipping_terms: "Termos de Envio",
	show: "Mostrar",
	show_all: "Mostrar Tudo",
	show_company_stock_page: "Mostrar Página de Estoque da Empresa",
	show_in_stocks: "Mostrar na Página de Estoque",
	sign_in: "Entrar",
	sign_out: "Sair",
	sign_out_confirm_message: "Você confirma a saída?",
	sign_out_success_message: "Adeus.",
	sign_up: "Inscrever-se",
	sizes: "Tamanhos",
	social_media: "Mídias Sociais",
	social_media_account: "Conta de Mídias Sociais",
	start_time: "Hora de Início",
	status: "Status",
	stock: "Estoque",
	stock_details: "Detalhes do Estoque",
	stock_images: "Imagens de Estoque",
	stock_status: "Status Do Estoque",
	stocks: "Estoques",
	stocks_url: "Link de Estoque",
	subscribe: "Assinar",
	subscription: "Assinatura",
	subscription_info_message:
		"Você pode se beneficiar de todos os serviços ilimitadamente durante o período de assinatura.",
	subscription_warning_message:
		"**Suas informações de cartão serão armazenadas com segurança e sua assinatura será renovada regularmente, a menos que você a cancele.",
	success: "Sucesso",
	super: "Super",
	supported_files_img: "Arquivos suportados: JPG, PNG.",
	switch_language: "Mudar Idioma",
	switch_theme: "Mudar Tema",
	table_inputs: "Conteúdo da Tabela",
	target: "Meta",
	target_partner: "Parceiro Alvo",
	tax_number: "Número de Imposto",
	template: "Modelo",
	template_actions: "Ações de modelo",
	template_added: "Modelo adicionado",
	template_name: "Nome do Modelo",
	template_overwrite: "Salvar edições como novo modelo",
	template_save_info: "Os modelos salvos estarão disponíveis posteriormente para uso em faturas proforma e remessas.",
	template_updated: "Modelo atualizado",
	terms_of_sale_and_other_comments: "Termos de venda - Comentários",
	text_input: "Entrada de texto",
	theme: "Tema",
	this_month: "Este Mês",
	this_year: "Este Ano",
	title: "Título",
	to: "Para",
	toDelete: "Excluir",
	total: "Total",
	total_amount: "Quantia Total",
	total_price: "Preço Total",
	total_warning: "Se você alterar esses dados, o total não será mais calculado automaticamente.",
	tracking: "Rastreamento de Remessas",
	transaction_no: "Número da Transação",
	transactions: "Transações",
	try_for_free: "Experimente Grátis",
	type: "Tipo",
	types: "Tipos",
	un_archive: "Desarquivar",
	unit: "Unidade",
	unit_price: "Preço unitário",
	units: "Unidades",
	unloading_country: "País de Descarregamento",
	unloading_point: "Ponto de Descarregamento",
	unloading_port: "Porto de Descarregamento",
	unsubscribe: "Cancelar Assinatura",
	unsubscribe_confirm_message:
		"Se você cancelar a assinatura, não poderá usar os recursos do sistema de forma eficaz. Tem certeza de que deseja cancelar a assinatura?",
	upload_new_image: "Carregar nova imagem",
	use_code: "Usar Código",
	use_invitation_code: "Usar Código de Convite",
	use_invitation_code_description: "Digite seu código de convite enviado para sua caixa de correio.",
	use_invitation_code_success_message: "O código de convite foi usado com sucesso.",
	user_profile: "Meu Perfil",
	value: "Valor",
	variant: "Variante",
	variants: "Variantes",
	vehicle: "Veículo",
	vehicles: "Veículos",
	verified_partner: "Parceiro Verificado",
	verify_password: "Verificar senha",
	visibility: "Visibilidade",
	warehouse: "Armazém",
	warehouses: "Armazéns",
	warn_unsaved_measurement: "Não se esqueça de clicar em ‘+’ para adicionar suas medições.",
	website: "Site",
	week: "Semana",
	weight: "Peso",
	weight_kg: "Peso (kg)",
	welcome: "Bem-vindo",
	what_we_are_doing: "O que estamos fazendo",
	width: "Largura",
	year: "Ano",
	year_lowercase: "ano",
	yearly: "Anual",
	yes: "Sim",
	yes_no: "Sim / Não",
	you_dont_have_any_active_subscription: "Você não tem nenhuma assinatura ativa",
};
